import {
  useGetDigitalBillIsEnabledForLocation,
  useIsFailedPaymentPromptEnabled,
  useIsQuickerLoginEnabledForLocation,
} from '@ordr-as/ordr-service-types/epos';
import { isValidLocationId, isValidNumericLocationId } from '../utils/locationId';

export function useQueryDigitalBillFeatureFlag(id?: number) {
  const { queryKey: _queryKey, ...result } = useGetDigitalBillIsEnabledForLocation(id ?? 0, {
    query: {
      enabled: isValidNumericLocationId(id),
      staleTime: 5 * 60 * 1000, // 5 min
    },
  });
  return result;
}

export function useQuickerLoginEnabled(id?: number) {
  const { queryKey: _queryKey, ...result } = useIsQuickerLoginEnabledForLocation(id ?? 0, {
    query: {
      enabled: isValidNumericLocationId(id),
      staleTime: 5 * 60 * 1000, // 5 min
    },
  });
  return result;
}

export function useQueryFailedPaymentPromptFeatureFlag(locationId?: string) {
  const { queryKey: _queryKey, ...result } = useIsFailedPaymentPromptEnabled(locationId ?? '', {
    query: {
      enabled: isValidLocationId(locationId),
      staleTime: 5 * 60 * 1000, // 5 min
    },
  });
  return result;
}
